import { render, staticRenderFns } from "./FuncionarioEstatisticaGeral.vue?vue&type=template&id=56020214&"
import script from "./FuncionarioEstatisticaGeral.vue?vue&type=script&lang=js&"
export * from "./FuncionarioEstatisticaGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports